import { Box } from '@hivebrite/design-system/Box';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useFeature } from 'hb-react/shared/hooks/useFeature';
import { FormikRecaptcha } from 'hb-react/shared/utils/recaptcha';

export const ReCaptcha = () => {
  const { feature: events } = useFeature('events');
  const { currentUser } = useDefaultAppContexts();

  if (
    !events.config?.public_form_recaptcha_enabled ||
    window.is_from_china ||
    currentUser
  ) {
    return null;
  }

  return (
    <Box mt={5}>
      <FormikRecaptcha />
    </Box>
  );
};
